import React, { useEffect, useState } from "react";
import CompWrapper from "../../hoc/compWrapper/CompWrapper.hoc";
import Title from "../../common/title/Title.common";
import IMAGE from "../../../assets/images/station.webp";
import { useAuth } from "react-uicomp";
import { api, APIS, FILE_URL } from "../../../config/Config";

import HTMLParser from "react-html-parser";

// import
export const StationChiefDesk = () => {
  const { setHeaderTitle } = useAuth();
  const [stationManager, setStationManager] = useState();
  useEffect(() => {
    setHeaderTitle("Station Chief");
  }, [setHeaderTitle]);

  useEffect(() => {
    (async () => {
      const res = await api(`${APIS.station_chief}`);
      const { success, data } = res.data;
      if (success === "true") {
        setStationManager(data?.data?.rows[0]);
      }
    })();
  }, []);

  return (
    <CompWrapper>
      {!!stationManager ? (
        <div className="station-chief-main-wrapper">
          <div className="station-chief-container">
            <div className="station-chief-image">
              <img
                src={FILE_URL + stationManager?.thumbnail}
                alt="station chief"
              />
            </div>
            <div className="station-chief-message-wrapper">
              <div className="station-chief-title">
                Message from Station Chief
              </div>
              <p>{HTMLParser(stationManager?.description?.desc?.en)}</p>
            </div>
          </div>
        </div>
      ) : (
        <div>Loading...</div>
      )}
    </CompWrapper>
  );
};
